export default __webpack_public_path__ + "static/media/NissanFav.85eb3c38.ico";